import { useLang } from "@/context/LangContext";
import Seo from "@/components/Seo";
import { PAGE_SEO } from "@/lib/seo";
import Hero from "@/sections/Hero";
import Marquee from "@/components/Marquee";
import Enemies from "@/sections/Enemies";
import Manifesto from "@/sections/Manifesto";
import ProductShowcase from "@/sections/ProductShowcase";
import MerchDropTeaser from "@/sections/MerchDropTeaser";
import DropCountdown from "@/sections/DropCountdown";
import SocialMockups from "@/sections/SocialMockups";
import CreatorsStrip from "@/sections/CreatorsStrip";
import Community from "@/sections/Community";

const Home = () => {
  const { t } = useLang();
  return (
    <div data-testid="page-home">
      <Seo {...PAGE_SEO.home} />
      <Hero />
      <Marquee text={t.marquee} />
      <Enemies />
      <Manifesto />
      <Marquee text={t.marquee} reverse bg="bg-lime" color="text-ink" />
      <ProductShowcase />
      <MerchDropTeaser />
      <DropCountdown />
      <SocialMockups />
      <CreatorsStrip />
      <Community />
    </div>
  );
};

export default Home;
